angular.module('bmsApp.settings').factory('VATRateSvc', function ($http, $log, $window, $q, CRUDSvc, VAT_RATE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(VAT_RATE_API.INDEX, params);
		},
		update: function (data) {
			return CRUDSvc.post(VAT_RATE_API.UPDATE, data);
		}
	}

}).constant('VAT_RATE_API', {
	INDEX: 'api/settings/vatRates/index',
	UPDATE: 'api/settings/vatRate/update'
});




